import { axiosClientAdmin } from "@/lib/auth";
import { Comparator, FilterOperator, GetSearchTenantsTenantMonitoringData, SortOrder, TenantMonitoringCompaniesSearched } from "../types.gen";
import { SearchInput, SearchInputBase } from "../util/types";
import { UseQueryOptions } from "@tanstack/react-query";

export type SearchTenantMonitoringCompaniesInput = SearchInputBase
  & { tenantId: string, searchTerm?: string }

export const searchTenantMonitoringCompanies = async (input: SearchTenantMonitoringCompaniesInput): Promise<TenantMonitoringCompaniesSearched> => {
  const pathTpl: GetSearchTenantsTenantMonitoringData["url"] = "/tenants/{tenantId}/TenantMonitoring/companies/search"

  const { tenantId, searchTerm, ...rest } = input;

  const search = new SearchInput({
    sortBy: "name",
    sortDir: SortOrder.Ascending,
    ...rest
  })

  if (searchTerm) {
    search.filterFilterGroups.push({
      operator: FilterOperator.Or,
      filters: [
        {
          field: "name",
          action: Comparator.ILike,
          value: searchTerm
        }
      ]
    })
  }

  const response = await axiosClientAdmin.get<TenantMonitoringCompaniesSearched>(
    pathTpl.replace("{tenantId}", tenantId),
    { params: search.toParams() }
  );

  return response.data
}


export const SearchTenantMonitoringCompaniesQuery = (input: SearchTenantMonitoringCompaniesInput) => {
  return {
    queryKey: ['tenants.monitoring-companies.search', input],
    queryFn: () => searchTenantMonitoringCompanies(input),
  } satisfies UseQueryOptions
}

